import Pagination from "@mui/material/Pagination";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";

import styles from "./styles.module.css";
import { useContext } from "react";
import useFilterParams from "./useFilterParams";
import { downloadReceiptPdf } from "../../Classes/API/ReceiptsApi";
import { LanguageContext } from "App";

const ReceiptsTable = ({ receipts, totalCount, pageNumber, pageSize }) => {
  const { onFilterChange, getInitialFilters } = useFilterParams();
  const { translations } = useContext(LanguageContext);

  const filters = getInitialFilters();

  const handleInputChange = (e, value) => {
    const updatedFilters = { ...filters, page: value };
    onFilterChange(updatedFilters);
  };

  const TableColumns = [
    {
      Header: translations.ReceiptId,
      accessor: "receiptId",
      align: "left",
    },
    {
      Header: translations.appointmentAppointmentsScheduleDate,
      accessor: "date",
      align: "left",
    },
    {
      Header: translations.CreateAccountingEntrypgAmount,
      accessor: "amount",
      align: "left",
    },
    {
      Header: translations.LogsSearchType,
      accessor: "entryType",
      align: "left",
    },
    {
      Header: translations.PatientStaytablePatient,
      accessor: "patientName",
      align: "left",
    },
    {
      Header: "",
      accessor: "view",
      align: "left",
    },
  ];

  return (
    <>
      <MDBox
        mt={-1}
        py={3}
        px={2}
        bgColor="info"
        coloredShadow="info"
        align="center"
        sx={{
          borderTopLeftRadius: "1.1rem",
          borderTopRightRadius: "1.1rem",
          backgroundColor: "#3560AD",
        }}
      >
        <MDTypography variant="h4" color="white">
          {translations.ReceiptsTable}
        </MDTypography>
        <MDTypography variant="h5" color="white">
          {totalCount}
        </MDTypography>
      </MDBox>

      <MDBox p={3}>
        <DataTable
          table={{
            columns: TableColumns,
            rows: receipts?.map((r) => ({
              ...r,
              patientName: r.patient?.name || "N/A",
              date: new Date(r.date).toLocaleDateString(),
              view: (
                <MDTypography
                  component="button"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  sx={{
                    minWidth: "auto",
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    cursor: "pointer",
                    padding: 0,
                    margin: 0,
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  onClick={async () => {
                    try {
                      const blob = await downloadReceiptPdf(r.receiptId);
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `receipt-${r.receiptId}.pdf`;
                      document.body.appendChild(a);
                      a.click();
                      window.URL.revokeObjectURL(url);
                      document.body.removeChild(a);
                    } catch (error) {
                      console.error("Download failed:", error);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                    width="1.25em"
                    height="1.25em"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                    />
                  </svg>
                </MDTypography>
              ),
            })),
          }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />

        <div className={styles["pagination-container"]}>
          <div className={styles["pagination-counter"]}>
            Showing{" "}
            <span className={styles["pagination-items-indicator"]}>
              {pageSize * (pageNumber - 1) + 1} -{" "}
              {Math.min(pageSize * pageNumber, totalCount)}
            </span>{" "}
            of{" "}
            <span className={styles["pagination-items-indicator"]}>
              {totalCount}
            </span>
          </div>
          <Pagination
            page={pageNumber}
            count={Math.ceil(totalCount / pageSize)}
            color="primary"
            onChange={handleInputChange}
            className="float-right"
          />
        </div>
      </MDBox>
    </>
  );
};

export default ReceiptsTable;
